/* eslint-disable react/no-unknown-property */
/* eslint-disable max-len */
import React from 'react';

/**
 * CoursesIcon - Auto-generated from icon.js
 */
export const CoursesIcon = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M3 12C3 7.032 7.032 3 12 3C16.968 3 21 7.032 21 12C21 16.968 16.968 21 12 21C7.032 21 3 16.968 3 12ZM4.08 12C4.08 16.374 7.626 19.92 12 19.92C16.374 19.92 19.92 16.374 19.92 12C19.92 7.626 16.374 4.08 12 4.08C7.626 4.08 4.08 7.626 4.08 12ZM9.56994 7.68L16.4999 11.532C16.6619 11.622 16.7699 11.802 16.7699 12C16.7699 12.198 16.6799 12.378 16.4999 12.468L9.56994 16.302C9.47994 16.356 9.38994 16.374 9.29994 16.374C9.20994 16.374 9.11994 16.356 9.02994 16.302C8.86794 16.194 8.75994 16.032 8.75994 15.834V8.148C8.75994 7.95 8.86794 7.77 9.02994 7.68C9.20994 7.59 9.40794 7.59 9.56994 7.68ZM15.1139 12L9.83994 9.066V14.934L15.1139 12Z"
			fill="current"
		/>
	</svg>
);

export default CoursesIcon;
